import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Routes from "./Routes";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";
import { TranslationProvider } from "./contexts/TranslationContext";
import { SettingsProvider, useSettings } from "./contexts/SettingsContext";
import { AudioPlayerProvider } from "./contexts/AudioPlayerContext";
import CustomCodeInjector from "./components/CustomCodeInjector";

// Component that uses settings — must be a direct child of SettingsProvider
const AppContent: React.FC = () => {
  const { radioStreamUrl } = useSettings();

  const streamUrl = radioStreamUrl && radioStreamUrl.trim() !== ""
    ? radioStreamUrl
    : "";

  return (
    <TranslationProvider>
      <AudioPlayerProvider streamUrl={streamUrl}>
        <CustomCodeInjector />
        <Routes />
        <ToastContainer
          position="top-right"
          autoClose={10000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </AudioPlayerProvider>
    </TranslationProvider>
  );
};

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <SettingsProvider>
          <AppContent />
        </SettingsProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;